export default "__VITE_ASSET__55f651b8__"